import { sendGTMEvent } from "@frend-digital/events/gtm";

export interface ShoeFinderStepCompletePayload {
	stepIndex: number;
	stepUid: string;
	stepTitle: string;
	selectedUids: string[];
	selectedLabels: string[];
	isSkipped: boolean;
	isLastStep: boolean;
}

export interface ShoeFinderCompletePayload {
	resultCount: number;
	selections: Array<{
		stepUid: string;
		stepTitle: string;
		selectedUids: string[];
		selectedLabels: string[];
	}>;
}

export const trackShoeFinderStart = () => {
	sendGTMEvent({ event: "shoe_finder_start" });
};

export const trackShoeFinderStepComplete = (payload: ShoeFinderStepCompletePayload) => {
	sendGTMEvent({
		event: "shoe_finder_step_complete",
		step_index: payload.stepIndex,
		step_uid: payload.stepUid,
		step_title: payload.stepTitle,
		selected_uids: payload.selectedUids,
		selected_labels: payload.selectedLabels,
		is_skipped: payload.isSkipped,
		is_last_step: payload.isLastStep,
	});
};

export const trackShoeFinderComplete = (payload: ShoeFinderCompletePayload) => {
	sendGTMEvent({
		event: "shoe_finder_complete",
		result_count: payload.resultCount,
		selections: payload.selections.map((s) => ({
			step_uid: s.stepUid,
			step_title: s.stepTitle,
			selected_uids: s.selectedUids,
			selected_labels: s.selectedLabels,
		})),
	});
};
